import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigation = [
    { name: 'Soluções', href: '#services' },
    { name: 'Diferenciais', href: '#expertise' },
    { name: 'Quem Somos', href: '#team' },
    { name: 'Contato', href: '#contact' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 滚动到联系区域
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5544999957005', '_blank');
  };

  // 通用滚动函数
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-4 md:py-6">
      <nav className="w-full px-4 md:px-6 lg:px-12">
        <div className="md:bg-primary/95 md:backdrop-blur-md md:px-8 md:py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/67e380c3df490f4157fd930f5cd9671a.png"
                  alt="LicitMax"
                  width={548}
                  height={526}
                  fetchPriority="high"
                  className="h-[50px] md:h-[86px] w-auto"
                />
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <button
                type="button"
                onClick={() => scrollToSection('services')}
                className="text-white/90 hover:text-accent transition-colors text-base font-medium cursor-pointer"
              >
                Soluções
              </button>
              <button
                type="button"
                onClick={() => scrollToSection('expertise')}
                className="text-white/90 hover:text-accent transition-colors text-base font-medium cursor-pointer"
              >
                Diferenciais
              </button>
              <button
                type="button"
                onClick={() => scrollToSection('team')}
                className="text-white/90 hover:text-accent transition-colors text-base font-medium cursor-pointer"
              >
                Quem Somos
              </button>
              <button
                type="button"
                onClick={() => scrollToSection('contact')}
                className="text-white/90 hover:text-accent transition-colors text-base font-medium cursor-pointer"
              >
                Contato
              </button>
              <button 
                onClick={handleWhatsAppClick}
                className="bg-accent text-primary px-6 py-2 text-base font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer rounded-full shadow-md hover:shadow-lg hover:scale-105"
              >
                Falar no WhatsApp
              </button>
            </div>

            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-white hover:text-white/80 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden bg-primary/95 backdrop-blur-md border-t border-white/20 mt-4 pt-4 px-4 pb-4 rounded-lg">
              <div className="space-y-4">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      scrollToSection(item.href.replace('#', ''));
                      setIsMenuOpen(false);
                    }}
                    className="block text-white/90 hover:text-white font-medium cursor-pointer w-full text-left"
                  >
                    {item.name}
                  </button>
                ))}
                <button 
                  onClick={handleWhatsAppClick}
                  className="w-full bg-accent text-primary px-6 py-2 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer rounded-full shadow-md hover:scale-105"
                >
                  Falar no WhatsApp
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}
